import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { ReplaySubject } from 'rxjs/ReplaySubject'
import { Bureau } from '../../pkw-data/core/bureau.model'
import { PkwDatastoreIdentificacao } from '../../pkw-data/pkw-datastore-identificacao'

@Injectable()
export class BureauService {
    corrente: Observable<Bureau>

    private _corrente: ReplaySubject<Bureau>

    constructor(private pkwDatastoreIdentificacao: PkwDatastoreIdentificacao) {
        this._corrente = new ReplaySubject<Bureau>(1)
        this.corrente = this._corrente.asObservable()
    }

    obterCorrente() {
        return this.pkwDatastoreIdentificacao
            .findRecord(Bureau, '1', {
                include: 'userConnection',
            })
            .map((bureau) => {
                this._corrente.next(bureau)

                return bureau
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/bureau.service.ts